import { call, take, put, race } from 'typed-redux-saga';
import { sendNow, events } from '@elevio/js-analytics';
import { getNonce } from '../api/nonce';
import * as articleFeedbackActions from '../actions/articleFeedback';
import * as pageActions from '../actions/page';
import { reportError } from '../bugTracking';
export function* submitArticleFeedback(action) {
    const { articleId, isPositive, title } = action.payload;
    try {
        yield* call(sendNow, [
            events.articleFeedbackReaction({
                articleId: articleId,
                isPositive: isPositive,
                articleTitle: title,
            }),
        ]);
        yield* put(articleFeedbackActions.Actions.feedbackReactionSubmitted(articleId, isPositive));
    }
    catch (error) {
        yield* put(articleFeedbackActions.Actions.feedbackReactionError(articleId, isPositive));
        reportError(error);
    }
}
// if the page changes, cancel the in progress sending of the event.
export function* watchArticleFeedback() {
    while (true) {
        const action = yield* take(articleFeedbackActions.ActionTypes.FEEDBACK_REACTION_PRESSED);
        yield* race({
            task: call(submitArticleFeedback, action),
            cancel: take(pageActions.ActionTypes.PAGE_NAV_COMPLETE),
        });
    }
}
function* submitArticleFeedbackForm(action) {
    const { articleId, title, formData } = action.payload;
    try {
        const nonce = yield* call(getNonce);
        yield* call(sendNow, [
            events.articleFeedbackText({
                articleId: articleId,
                email: formData.email,
                feedbackMessage: formData.feedback,
                articleTitle: title,
                nonce: nonce,
            }),
        ]);
        yield* put(articleFeedbackActions.Actions.negativeFeedbackSubmitSuccess(articleId));
    }
    catch (error) {
        yield* put(articleFeedbackActions.Actions.negativeFeedbackSubmitError(articleId));
        reportError(error);
    }
}
// if the page changes, cancel the in progress sending of the event.
export function* watchArticleFeedbackForm() {
    while (true) {
        const action = yield* take(articleFeedbackActions.ActionTypes.NEGATIVE_FEEDBACK_SUBMIT);
        yield* race({
            task: call(submitArticleFeedbackForm, action),
            cancel: take(pageActions.ActionTypes.PAGE_NAV_COMPLETE),
        });
    }
}
//# sourceMappingURL=articleFeedback.js.map